import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next'; 

import React, { Component } from 'react'
import { RichText } from '@sitecore-jss/sitecore-jss-react';

import '../assets/css/0020_objects/0880_obj_intro_home_comptoir_dermato.css'
import '../assets/css/0020_objects/0890_obj_tabs_home_comptoir_dermato.css'

class PageBrandAv_Intro extends Component {
    constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
        const { scDatas } = this.props.fields.data;

        return (<>{scDatas && <>
			<section className="obj_section obj_intro_home_comptoir_dermato">
				<div className="ctn_title">
                    { scDatas.pageText.jss && <RichText tag="p" className="t_desc" field={scDatas.pageText.jss} /> }
				</div>
			</section>
        </>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(PageBrandAv_Intro));